module.exports = __webpack_public_path__ + "img/linkedin.2e6c1c6e.svg";